
import { defineComponent, PropType } from 'vue'
import { Modal } from 'ant-design-vue'
import { EditOutlined, EllipsisOutlined, CopyOutlined, DeleteOutlined, DownloadOutlined } from '@ant-design/icons-vue'
import { TemplateProps } from '@/store/templates'
import { DEFAULT_COVER_IMAGE } from '@/utils/consts'

export default defineComponent({
  name: 'WorksList',
  components: {
    EditOutlined,
    EllipsisOutlined,
    CopyOutlined,
    DeleteOutlined,
    DownloadOutlined
  },
  props: {
    list: {
      type: Array as PropType<TemplateProps[]>,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    transferStatus: {
      type: Boolean,
      default: false
    }
  },
  emits: ['on-copy', 'on-delete'],
  setup(props, context) {
    const deleteClicked = (id: number) => {
      Modal.confirm({
        title: '确定要删除该作品吗？',
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk: () => {
          context.emit('on-delete', id)
        }
      })
    }
    const copyClicked = (id: number) => {
      context.emit('on-copy', id)
    }

    return {
      deleteClicked,
      copyClicked,
      DEFAULT_COVER_IMAGE
    }
  }
})
